import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './header'
import Menu from './menu'
import GamesService from '../services/casinoGamesService'
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID } from '../configs/const';
import '../css/casino/index.css'
import '../css/casino/style.css'
import '../css/casino/responsive.css'
let oid = OPERATOR_ID.toLowerCase()

class Casino extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            games: [],
            allGames: [],
            showPopup: false,
            operator: OPERATOR_ID,
            gameType: "new",
            gameCategory: "All",
            openGame: false,
            link: "",
            loader: true
        };
    }
    componentDidMount() {
        const operator = this.state.operator
        let token = JSON.parse(localStorage.getItem('userAuthDetail'))
        token = !!token ? token.token : null
        if (!!operator && !!token) {
            window.localStorage.setItem("operator", operator);
            window.localStorage.setItem("token", token);
            GamesService.getEvolveCasino().then((res) => {
                if (!!res.data && res.data.length > 0) {
                    let games = res.data.sort((a, b) => (a.category > b.category) ? 1 : ((b.category > a.category) ? -1 : 0))
                    this.setState({ games: games })
                }
                this.setState({ loader: false })
            })
        }
    }
    getIndividualGame = async (gameId) => {
        this.setState({ isLoading: true });
        const gameRes = await GamesService.getIndividualGame(gameId);
        const gameData = gameRes.data;
        if (!gameData && !gameRes.isSuccess && !!gameRes?.exception?.message) {
            this.props.MySwal.fire({
                title: 'Error',
                text: `${gameRes?.exception?.code} ${gameRes?.exception?.message}`,
                icon: 'error',
                confirmButtonText: 'OK',
            })
            this.setState({ loader: false });
            // this.setState({ showPopup: true, popupMessage: gameRes.message });
        }
        if (!!gameData && !!gameData.url) {
            this.setState({ openGame: true, link: gameData.url })
        }
    }
    render() {
        let accData = JSON.parse(localStorage.getItem("accountData"));
        return (
            <body className="radheexch">
                <Header notify={this.props.notify} showSweetAlert={(options) => this.props.showSweetAlert(options)} MySwal={this.props.MySwal} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} history={this.props.history} socket={this.props.socket} />
                <div className={`full-wrap mar-top100 footerpd ${(!!accData && Object.keys(accData).length > 0) ? '' : 'mar-top100-login mar-bottom0'}`}>
                    <Menu history={this.props.history} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} />
                    {/* <div className="col-center1 markets">
                        <div className="test" >
                            <iframe title={"iframe"} key={"iframe"} style={{ height: "84vh", width: "100%", border: "0px" }} src={this.state.link}></iframe>
                        </div>
                    </div> */}
                    <div className="col-center1 markets">
                        <section>
                            <div className={`container-fluid casino-content-page ${this.state.operator}`} >
                                {this.state.openGame !== true ? <>
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="loader-bg" style={{ display: this.state.loader ? "flex" : "none" }}>
                                                <img alt="" src={BASE_IMAGE_PATH + "/" + oid + "/uimg/loader.gif"} className={`${this.state.loader ? "loader-image-active" : "loader-image-active"}`} />
                                            </div>
                                        </div>
                                    </div>
                                    {!this.state.loader &&
                                        <>
                                            <div className="row">
                                                <div className="text-center">
                                                    {<img alt="" src={BASE_IMAGE_PATH + "/casino/banner/casino2banner.jpg"} ></img>}
                                                </div>
                                            </div>
                                            <div className="row mt-4 mb-2 featured-game1">
                                                {
                                                    this.state.games.map((game) => (
                                                        <div className="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3" key={game.gameId} onClick={() => this.getIndividualGame(game.gameId)}>
                                                            <div className="img-pos">
                                                                <img alt="" src={BASE_IMAGE_PATH + `/casino/img/${game.gameId}.jpg`} className="img-fluid" />
                                                                {
                                                                    game.isNew &&
                                                                    <div className="newgame"></div>
                                                                }
                                                                {
                                                                    game.isPopular &&
                                                                    <div className="hotgame"></div>
                                                                }
                                                            </div>
                                                            <div className="text-center game-title-main">{game.gameName}</div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        </>}
                                </> :
                                    <div className="row">
                                        <div onClick={() => { this.setState({ openGame: false, isLoading: false }) }} style={{ position: "absolute", width: "30px", textAlign: "center" }}><i className="fa fa-times popup-cross"></i></div>
                                        <iframe title={"iframe"} key={"iframe"} style={{ height: "84vh", width: "100%", border: "0px" }} src={this.state.link}></iframe>
                                    </div>
                                }
                            </div>
                        </section>
                    </div>
                </div>
            </body>
        )
    }
}
function mapStateToProps(state) {
    return {
    };
}
function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Casino);